import React, { useEffect } from "react";
import './searchInput.css'
import { ReactComponent as SearchIcon } from "../../../../assets/images/search-icon.svg";
import { hasSpecialCharacters } from "../../../../constants/helper";
import { preventUserToAddSymbol } from "../../../../constants/helper";

const SearchInput = ({defaultValue, type, placeholder, onChange, debounceDelay = 300, iconPosition = "left", iconSrc, iconFilled = false, filledColor = "#EEEEEE",value = "",...props }) => {
  
  const handleInputChange = (e) => {
    if (onChange) {
      const handleChange = (e) => {
        const newValue = e.target.value;
        if (!hasSpecialCharacters(newValue)) {
          // onChange(e);
          onChange(e.target.value);
        } 
      };
      handleChange(e);
      
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      if (onChange) {
        onChange(value);
      }
    }, debounceDelay);

    return () => {
      clearTimeout(timer);
    };
  }, [value, onChange, debounceDelay]);


console.log("search input", value)
  return (
    <div className="search-input">
      <input autoComplete="off" value={value} onKeyDown={preventUserToAddSymbol}  suffix={iconPosition === "right" ? iconSrc : null} type="text" placeholder={placeholder || "Search"} className="search-input-toggler w-full h-full" onChange={handleInputChange} style={{ "--placeholder-size": "12px" }} />
      <SearchIcon className="icon"/>
    </div>
  );
};

export default SearchInput;
